import {
  Alert,
  CardActions,
  CardHeader,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Stack,
} from "@mui/material";
import { useEffect, useState } from "react";
import AppButton from "../../shares/AppButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { DeleteOutline, EditOutlined, InfoOutlined } from "@material-ui/icons";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import AutreCompetenceForm from "./forms/AutreCompetenceForm";
import { useQuery } from "../../../../hooks/useQuery";
import useConfirm from "../../../../hooks/useConfirm";
import useToast from "../../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";
import { CVAutreCompetenceService } from "../../../../service/CVAutreCompetenceService";

const AutreCompetence = () => {
  const [autreCompetences, setAutreCompetences] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const query = useQuery();
  const id_user = query.get("ref");
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const { Toast, showToast } = useToast();

  const handleCloseEducationForn = () => {
    setFormOpen(false);
    handleFetchAutreCompetences();
  };

  const handleOpenEducationFormDialog = (education) => {
    setSelectedId(null);
    setFormOpen(true);
  };

  const handleUpdateAutreCompetence = (competence) => {
    setSelectedId(competence);
    setFormOpen(true);
  };

  const confirmDelete = (autreCompetence) => {
    CVAutreCompetenceService.delete({
      id_autre_competence: autreCompetence.id_autre_competence,
    }).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchAutreCompetences({
          id_identite: id_user,
        });
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleDeleteAutreCompetence = (autreCompetence) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => confirmDelete(autreCompetence),
    );
  };

  const handleFetchAutreCompetences = () => {
    setFormLoading(true);
    CVAutreCompetenceService.liste({
      id_ext_user: id_user,
    })
      .then((res) => {
        if (res && res.data) {
          setAutreCompetences(res.data);
        }
      })
      .finally(() => {
        setFormLoading(false);
      });
  };

  useEffect(() => {
    handleFetchAutreCompetences();
  }, []);

  return (
    <>
      <DialogComponent />
      <Toast />
      <AutreCompetenceForm
        open={formOpen}
        onFormClose={handleCloseEducationForn}
        idAutreCompetence={selectedId}
      />
      <Paper>
        <LinearProgress
          sx={{
            borderRadius: "3px 3px 0 0",
            display: formLoading ? "" : "none",
          }}
        />
        <Grid item xs={12} width={"100%"}>
          <CardHeader
            sx={{ m: 2 }}
            title="Langues et autres competences"
            titleTypographyProps={{ fontWeight: "bold" }}
            action={
              <Grid>
                <AppButton
                  icon={<AddCircleOutlineOutlinedIcon />}
                  text={"Ajouter"}
                  onClick={handleOpenEducationFormDialog}
                  variant={"outlined"}
                />
              </Grid>
            }
          />
          {autreCompetences.length > 0 ? (
            autreCompetences.map((item, index) => (
              <Grid key={index}>
                <ul>
                  <CardHeader
                    titleTypographyProps={{
                      color: "primary",
                      sx: {
                        fontSize: "20px",
                        fontWeight: "bold",
                        mb: 1,
                      },
                    }}
                    title={`${item.type}`}
                    subheader={
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={4}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <AccountTreeOutlinedIcon />
                            <span>
                              <b>Type :</b> <br />
                              {` ${item.competence || ""}`}
                            </span>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <TrendingUpOutlinedIcon />
                            <span>
                              <span>
                                <b>Capacité :</b> <br />
                                {` ${item.niveau || ""}`}
                              </span>
                            </span>
                          </Stack>
                        </Grid>
                      </Grid>
                    }
                  />
                  <CardActions sx={{ justifyContent: "flex-end", mr: 2 }}>
                    <AppButton
                      icon={<EditOutlined />}
                      onClick={(e) =>
                        handleUpdateAutreCompetence(item.id_autre_competence)
                      }
                      text={"Modifier"}
                      variant={"outlined"}
                    />
                    <AppButton
                      icon={<DeleteOutline />}
                      onClick={(e) => handleDeleteAutreCompetence(item)}
                      text={"Supprimer"}
                      color={"warning"}
                      variant={"outlined"}
                    />
                  </CardActions>
                </ul>
                <Divider variant="middle" />
              </Grid>
            ))
          ) : (
            <Grid item p={3}>
              <Alert variant="outlined" color="info" icon={<InfoOutlined />}>
                Aucune information
              </Alert>
            </Grid>
          )}
        </Grid>
      </Paper>
    </>
  );
};

export default AutreCompetence;
